import { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Lightbox } from "@/components/site/Lightbox";
import { PageHead } from "@/components/site/PageHead";

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [lb, setLb] = useState(null);
  useEffect(() => { api.get("/photos").then((r) => setPhotos(r.data)); }, []);

  return (
    <div data-testid="gallery-page">
      <PageHead eyebrow="Dall'officina" title="Galleria" script="lavori" sub="Auto in officina, interventi e risultati: il nostro lavoro, senza filtri." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        {photos.length === 0 && <p className="text-zinc-500" data-testid="gallery-empty">Nessuna foto disponibile.</p>}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
          {photos.map((p, i) => (
            <button key={p.id} onClick={() => setLb(i)} className="group relative block w-full overflow-hidden reveal" style={{ animationDelay: `${i * 50}ms` }} data-testid={`gallery-photo-${i}`}>
              <img src={imgUrl(p.url)} alt={p.title} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              {p.title && <span className="absolute bottom-4 left-4 font-display italic uppercase font-bold tracking-wider opacity-0 group-hover:opacity-100 transition-opacity">{p.title}</span>}
            </button>
          ))}
        </div>
      </section>
      <Lightbox photos={photos} index={lb} setIndex={setLb} />
    </div>
  );
}
